import moment from "moment";

/**
 * Calculate time difference between two timestamps and format as "Xh Ym", "Xh", "Ym", or "0m"
 * @param startTime - ISO timestamp string
 * @param endTime - ISO timestamp string (defaults to current UTC time)
 * @returns Formatted time difference: "Xh Ym" (hours and minutes), "Xh" (whole hours), "Ym" (minutes only), or "0m" (invalid/zero/negative diff)
 */
export const getTimeDifference = (
  startTime: string,
  endTime?: string
): string => {
  if (!startTime) {
    return "0m";
  }
  
  const start = moment.utc(startTime);
  
  if (!start.isValid()) {
    return "0m";
  }
  
  const end = endTime ? moment.utc(endTime) : moment.utc();
  
  // Validate end time if provided
  if (endTime && !end.isValid()) {
    return "0m";
  }
  
  const totalMinutes = end.diff(start, 'minutes');
  
  // Handle negative or zero cases
  if (totalMinutes <= 0) {
    return "0m";
  }
  
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  
  // More explicit formatting
  if (hours > 0 && minutes > 0) {
    return `${hours}h ${minutes}m`;
  } else if (hours > 0) {
    return `${hours}h`;
  } else {
    return `${minutes}m`;
  }
};
